import {
  Component, Input, forwardRef, OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  Output,
  EventEmitter
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-tags-input',
  templateUrl: './tags-input.component.html',
  styleUrls: ['./tags-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TagsInputComponent),
      multi: true
    }
  ]
})

export class TagsInputComponent implements ControlValueAccessor, OnInit, OnChanges  {
  @Input() options: { id: any, name: string }[] = [];
  @Input() placeholder: string = 'Select or add...';
  @Output() dataArrayEmitter = new EventEmitter<string[]>();

  selected: any[] = [];
  filteredOptions: { id: any, name: string }[] = [];
  inputValue = '';
  focusOn :boolean = false;

  private onChange = (_: any) => { };
  private onTouched = () => { };

  constructor(private cd: ChangeDetectorRef) {}


  items: string[] = ['Apple', 'Banana', 'Cherry'];

  ngOnInit() {
    this.filteredOptions = this.options;
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      this.filteredOptions = this.options;
      let tempSelected = this.selected;
      this.selected = [];
      this.selected = tempSelected;
      // this.cd.detectChanges();
    }
    this.sendArray();
  }

  writeValue(value: any[]): void {
    this.selected = value || [];
    this.filterOptions();
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }

  addTag(tag: { id: any, name: string }) {
    if (!this.selected.find(s => s == tag.id)) {
      this.selected.push(tag.id);
      this.onChange(this.selected);
      this.inputValue = '';
      this.focusOn = false;
      this.filterOptions();
    }
  }

  removeTag(tagId: any) {
    this.selected = this.selected.filter(id => id !== tagId);
    this.onChange(this.selected);
    this.filterOptions();
  }

  onInput(event: any) {
    this.inputValue = event.target.value;
    this.filterOptions();
    this.focusOn = true;
  }

  onInputFocusOut(event: any) {
    this.focusOn = false;
  }

  filterOptions() {
    if (!this.options) {
      this.filteredOptions = [];
      return;
    }
    this.sendArray();
    // const lower = this.inputValue.toLowerCase();
    this.filteredOptions = this.options.filter(opt =>
      // !this.selected.includes(opt.id) 
      !this.selected.some(id => id == opt.id)
    );
  }


  onAddNewTag() {
    // const tagName = this.inputValue.trim();
    // if (!tagName) return;

    // const newId = tagName.toLowerCase().replace(/\s+/g, '-');
    // const newTag = { id: newId, name: tagName };

    // this.options.push(newTag);
    // this.addTag(newTag);
  }

  sendArray() {
    this.dataArrayEmitter.emit(this.selected);
  }

  getOptionName(id: any): string {
    return this.options?.find(o => o.id == id)?.name || id;
  }
}
